
import React from "react";
import { SignatureImageImproved } from "../../utils/SignatureImage";

export const bankVoltageFormatter = (value) => {
  if (value === undefined || value === null) return "-";

  return (
    <div style={{textAlign:"center"}}>
     BANK VOLTAGE {value} VDC
    </div>
  );
};
const procedureFormatter = (value) => {
  if (value === true || value === "true") {
    return (
      <div style={{ textAlign: "center" }}>
        Procedure
      </div>
    );
  }

 
  return null;
};

export const BIAnnualTestSchema =[
  
      
  {
        heights: {
          header1: "auto",
          header2: "auto",
        },
        classes: { header1: "" },
        inlineBodyData: true,
        columns: [
          {
            title: "ITEM#",
            colSpan: 1,
            rowSpan: 1,
           isTitleOnly:true,
            // unBold: true,
            className: "tbl-text-normal",
            
          },
          {
            title: "INSPECTION DESCRIPTION",
            colSpan: 9,
            rowSpan: 1,
            isTitleOnly: true,
            
            // unBold: true,
            className: "tbl-text-normal",
          },
          {
            title: "Result",
            colSpan: 1,
            rowSpan: 1,
            isTitleOnly :true,
           
           
            // unBold: true,
            className: "tbl-text-normal",
            
          },
          {
            title: "Comments",
            colSpan: 4,
            rowSpan: 1,
            
            
            isTitleOnly :true,
           
            // unBold: true,
            className: "tbl-text-normal",
            dontJoinValues: true,
         
          },
          
        ],
      },
  {
        heights: {
          header1: "auto",
          header2: "auto",
        },
        classes: { header1: "" },
        inlineBodyData: true,
        columns: [
          {
            title: "1",
            colSpan: 1,
            rowSpan: 8,
           isTitleOnly: true,
            className: "tbl-text-normal",
            topAlign:true,
            
          },
          {
            title: "PRIMARY POWER",
            colSpan: 9,
            rowSpan: 1,
            isTitleOnly: true,
            leftAlign: true,
            
            className: "tbl-text-normal",
          },
          {
            title: "Result",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            unBold: true,
            className: "tbl-text-normal",
          
          },
          {
            title: "Comments",
            colSpan: 4,
            rowSpan: 1,
            isValueOnly: true,
          
            unBold: true,
            className: "tbl-text-normal",
            dontJoinValues: true,
           
          },
          
        ],
      },
      {
        heights: {
          header1: "auto",
          header2: "auto",
        },
        classes: { header1: "" },
        inlineBodyData: true,
        columns: [
          {
            title: "A. VERIFY 120 VAC PRESENT AND ALL CIRCUIT BREAKERS ARE IN THE PROPER POSITION.",
            colSpan: 9,
            rowSpan: 1,
            isTitleOnly: true,
            leftAlign: true,
            unBold: true,
            className: "tbl-text-normal",
          },
          {                                           
            title: "Result",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            unBold: true,
            className: "tbl-text-normal",
            accessor: "r1a",
          },
         
          {
            title: "Comments",
            colSpan: 4,
            rowSpan: 1,
            isValueOnly: true,
            accessor: "com50",
            // bindingAccessor: "cond2",
            // leftAlign:false,
            className: "tbl-text-normal",
          },
        ],
      },
      {
        heights: {
          header1: "auto",
          header2: "auto",
        },
        classes: { header1: "" },
        inlineBodyData: true,
        columns: [
          {
            title: "B.  VERIFY 12KVAC 3 PHASE IS PRESENT",
            colSpan: 9,
            rowSpan: 1,
            isTitleOnly: true,
            leftAlign: true,
            unBold: true,
            className: "tbl-text-normal",
          },
          {
            title: "Result",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            unBold: true,
            className: "tbl-text-normal",
            accessor: "it1b",
          },
          
          {
            title: "Comments",
            colSpan: 4,
            rowSpan: 1,
            isValueOnly: true,
            accessor: "com54",
            // bindingAccessor: "cond3",
            className: "tbl-text-normal",
          },
        ],
      },
      {
        heights: {
          header1: "auto",
          header2: "auto",
        },
        classes: { header1: "" },
        inlineBodyData: true,
        columns: [
          {
            title: "C.  VERIFY DC CONTROL VOLTAGE IS AT APPROPRIATE LEVEL ",
            colSpan: 9,
            rowSpan: 1,
            isTitleOnly: true,
            leftAlign: true,
            unBold: true,
            className: "tbl-text-normal",
          },
          {
            title: "Result",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            unBold: true,
            className: "tbl-text-normal",
            accessor: "it1c",
          },
         
          {
            title: "Comments",
            colSpan: 4,
            rowSpan: 1,
            isValueOnly: true,
            accessor: "com58",
            // bindingAccessor: "cond2",
            className: "tbl-text-normal",
          },
        ],
      },
      {
        heights: {
          header1: "auto",
          header2: "auto",
        },
        classes: { header1: "" },
        inlineBodyData: true,
        columns: [
          {
            title: "D.  SECURE BATTERY CHARGER AC SUPPLY. CHECK EACH BATTERY AND VERIFY 12VDC +/‐ 1VDC IS PRESENT",
            colSpan: 9,
            rowSpan: 1,
            isTitleOnly: true,
            leftAlign: true,
            unBold: true,
            className: "tbl-text-normal",
          },
          {
            title: "Result",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            unBold: true,
            className: "tbl-text-normal",
            accessor: "it1d",
          },
          
          {
            title: "Comments",
            colSpan: 4,
            rowSpan: 1,
            isValueOnly: true,
            accessor: "com62",
            // bindingAccessor: "cond3",
            className: "tbl-text-normal",
          },
        ],
      },
      {
        heights: {
          header1: "auto",
          header2: "auto",
        },
        classes: { header1: "" },
        inlineBodyData: true,
        columns: [
          {
            title: "E.  LEAVE CHARGER DEENERGIZED AND CONTINUE WITH INSPECTION. AFTER 15 MINUTES CHECK AND RECORD BATTERY BANK VOLTAGE. VERIFY BANK VOLTAGE IS 125‐135VDC.",
            colSpan: 9,
            rowSpan: 1,
            isTitleOnly: true,
            leftAlign: true,
            unBold: true,
            className: "tbl-text-normal",
          },
          {
            title: "Result",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            unBold: true,
            className: "tbl-text-normal",
            accessor: "it1e",
          },
         
          {
            title: "Comments",
            colSpan: 4,
            rowSpan: 1,
            isValueOnly: true,
            accessor: "com66",
            // bindingAccessor: "cond2",
            className: "tbl-text-normal",
          },
        ],
      },
      {
        heights: {
          header1: "auto",
          header2: "auto",
        },
        classes: { header1: "" },
        inlineBodyData: true,
        columns: [
          {
            title: "BANK VOLTAGE (VDC)",
            colSpan: 9,
            rowSpan: 1,
            // isValueOnly:true,
            isTitleOnly: true,
            // leftAlign: true,
            // formatter: bankVoltageFormatter,
            // accessor:"r1bankVoltage",
            unBold: true,
            className: "tbl-text-normal",
          },
          {
            title: "Result",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            unBold: true,
            className: "tbl-text-normal",
            disbale:true,
            // accessor: "it1e",
            accessor:"r1bankVoltage",
          },
         
          {
            title: "Comments",
            colSpan: 4,
            rowSpan: 1,
            isValueOnly: true,
            // accessor: "com66",
            // bindingAccessor: "cond2",
            className: "tbl-text-normal",
            disbale:true,
          },
        ],
      },
      {
        heights: {
          header1: "auto",
          header2: "auto",
        },
        classes: { header1: "" },
        inlineBodyData: true,
        columns: [
          {
            title: "F.  REENERGIZE THE CHARGER AND VERIFY THAT AFTER BATTERIES STABILIZE THAT THE CHARGE RATE IS 2.25 VDC PER CELL (135VDC)",
            colSpan: 9,
            rowSpan: 1,
            isTitleOnly: true,
            leftAlign: true,
            unBold: true,
            className: "tbl-text-normal",
          },
          {
            title: "Result",
            colSpan: 1,
            rowSpan: 1,
            isValueOnly: true,
            unBold: true,
            className: "tbl-text-normal",
            accessor: "it1f",
          },
          
          {
            title: "Comments",
            colSpan: 4,
            rowSpan: 1,
            isValueOnly: true,
            accessor: "com70",
            // bindingAccessor: "cond3",
            className: "tbl-text-normal",
          },
        ],
      },
      {
  heights: {
    header1: "auto",
    header2: "auto",
  },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "2",
      colSpan: 1,
      rowSpan: 11, 
      className: "tbl-text-normal",
      isTitleOnly: true,
      accessor: "desc",
      topAlign:true,
    },
    {
      title: "PROTECTIVE DEVICES",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      className: "tbl-text-normal",
    },
    {
      title: "Result",
      colSpan: 1,
      rowSpan: 1,
      isValueOnly: true,
      unBold: true,
      className: "tbl-text-normal",
      accessor: "cond1",
    },
    {
      title: "Comments",
      colSpan: 4,
      rowSpan: 1,
      isValueOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
      dontJoinValues: true,
    },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title:
        "A.  TEST RECTIFIER DIODE FAILURE ALARM BY ACTIVATING ANY ONE OF THE RECTIFIER DIODE FUSES. ENSURE YELLOW TROUBLE LIGHT AND BLUE LIGHT FLASH. ",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    {
      title: "Result",
      colSpan: 1,
      rowSpan: 1,
      isValueOnly: true,
      unBold: true,
      className: "tbl-text-normal",
      accessor: "it2a",
    },
    {
      title: "Comments",
      colSpan: 4,
      rowSpan: 1,
      isValueOnly: true,
      accessor: "com74",
      // bindingAccessor: "cond2",
      className: "tbl-text-normal",
    },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title:
        "B.  CHECK TRANSFORMER 1ST AND 2ND STAGE ANNUNCIATIONS BY OPENING DOOR OF TRANSFORMER FOR 1ST STAGE ALARM JUMPER TERMINALS 2 & 3 ON ETM PANEL, ENSURE 1ST STAGE LIGHT ILLUMINATES. FOR 2ND STAGE TRIP, REMOVE WIRE AT TERMINAL (6) B3 ENSURE 2ND STAGE ILLUMINATES AND 86 TRIPS RESTORE WIRING & RESET 86 DEVICE ",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    {
      title: "Result",
      colSpan: 1,
      rowSpan: 1,
      isValueOnly: true,
      unBold: true,
      className: "tbl-text-normal",
      accessor: "it2b",
    },
    {
      title: "Comments",
      colSpan: 4,
      rowSpan: 1,
      isValueOnly: true,
      accessor: "com78",
      // bindingAccessor: "co",
      className: "tbl-text-normal",
    },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title:
        "C.  TEST 64 DEVICE ENCLOSURE GROUND BY USING PUSH BUTTON ON FRONT OF RELAY. VERIFY DC ENCLOSURE GROUND ILLUMINATES.",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    {
      title: "Result",
      colSpan: 1,
      rowSpan: 1,
      isValueOnly: true,
      unBold: true,
      className: "tbl-text-normal",
      accessor: "it2c",
    },
    {
      title: "Comments",
      colSpan: 4,
      rowSpan: 1,
      isValueOnly: true,
      accessor: "com82",
      // bindingAccessor: "cond2",
      className: "tbl-text-normal",
    },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title:
        "D.  TEST 64 DEVICE ENCLOSURE LIVE BY USING PUSH BUTTON ON FRONT OF RELAY. VERIFY STRUCTURE LIVE ILLUMINATES & TRIPS 86 DEVICE. RESET THE 64 DEVICE AND 86 DEVICE",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    {
      title: "Result",
      colSpan: 1,
      rowSpan: 1,
      isValueOnly: true,
      unBold: true,
      className: "tbl-text-normal",
      accessor: "it2d",
    },
    {
      title: "Comments",
      colSpan: 4,
      rowSpan: 1,
      isValueOnly: true,
      accessor: "com86",
      bindingAccessor: "cond3",
      className: "tbl-text-normal",
    },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title:
        "E.  CHECK THE 33 DEVICE BY OPENING THE RECTIFIER DOOR. VERIFY THE 86 TRIPS. CLOSE THE RECTIFIER DOOR AND RESET THE 86 DEVICE",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    {
      title: "Result",
      colSpan: 1,
      rowSpan: 1,
      isValueOnly: true,
      unBold: true,
      className: "tbl-text-normal",
      accessor: "it2e",
    },
    {
      title: "Comments",
      colSpan: 4,
      rowSpan: 1,
      isValueOnly: true,
      accessor: "com90",
      // bindingAccessor: "cond2",
      className: "tbl-text-normal",
    },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title:
        "F.  TEST 26R DEVICE BY REMOVING WIRE AT TERMINAL RX2 10.1, OBSERVE 26R 1ST STAGE ALARM, RECONNECT WIRE. TEST 26RH BY REMOVING WIRE AT TERMINAL RX2 14.1 OBSERVE 2ND STAGE ILLUMINATED AND 86 TRIPS. RECONNECT WIRE AND RESET 86 DEVICE.",
     colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    {
      title: "Result",
      colSpan: 1,
      rowSpan: 1,
      isValueOnly: true,
      unBold: true,
      className: "tbl-text-normal",
      accessor: "it2f",
    },
    {
      title: "Comments",
      colSpan: 4,
      rowSpan: 1,
      isValueOnly: true,
      accessor: "com94",
      // bindingAccessor: "cond3",
      className: "tbl-text-normal",
    },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title:
        "G.  SIMULATE A EQUIPMENT DOOR OPEN BY OPENING THE NEGATIVE CUBICLE DOOR. VERIFY 86 TRIPS CLOSE DOOR AND RESET 86 DEVICE.",
     colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    {
      title: "Result",
      colSpan: 1,
      rowSpan: 1,
      isValueOnly: true,
      unBold: true,
      className: "tbl-text-normal",
      accessor: "it2g",
    },
    {
      title: "Comments",
      colSpan: 4,
      rowSpan: 1,
      isValueOnly: true,
      accessor: "com98",
      // bindingAccessor: "cond3",
      className: "tbl-text-normal",
    },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title:
        "H.  SIMULATE A EQUIPMENT DOOR OPEN BY OPENING THE TRANSFORMER DOOR. VERIFY 86 TRIPS CLOSE DOOR AND RESET 86 DEVICE.",
     colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    {
      title: "Result",
      colSpan: 1,
      rowSpan: 1,
      isValueOnly: true,
      unBold: true,
      className: "tbl-text-normal",
      accessor: "it2h",
    },
    {
      title: "Comments",
      colSpan: 4,
      rowSpan: 1,
      isValueOnly: true,
      accessor: "com102",
      // bindingAccessor: "cond3",
      className: "tbl-text-normal",
    },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title:
        "I.  TEST ESS SWITCHES BY ACTIVATING EACH SWITCH AND VERIFYING ON HMI PANEL. RESET 86 DEVICE.",
     colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    {
      title: "Result",
      colSpan: 1,
      rowSpan: 1,
      isValueOnly: true,
      unBold: true,
      className: "tbl-text-normal",
      accessor: "it2i",
    },
    {
      title: "Comments",
      colSpan: 4,
      rowSpan: 1,
      isValueOnly: true,
      accessor: "com106",
      // bindingAccessor: "cond3",
      className: "tbl-text-normal",
    },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title:
        "J.  START VENTS, ACTIVATE ONE OF THE SMOKE DETECTORS, ENSURE VENT STOPS & WILL NOT RESTART",
     colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    {
      title: "Result",
      colSpan: 1,
      rowSpan: 1,
      isValueOnly: true,
      unBold: true,
      className: "tbl-text-normal",
      accessor: "it2j",
    },
    {
      title: "Comments",
      colSpan: 4,
      rowSpan: 1,
      isValueOnly: true,
      accessor: "com110",
      // bindingAccessor: "cond3",
      className: "tbl-text-normal",
    },
  ],
},
{
  heights: {
    header1: "auto",
    header2: "auto",
  },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "3",
      colSpan: 1,
      rowSpan: 10,
      className: "tbl-text-normal",
      accessor: "desc",
      isTitleOnly:true,
      topAlign:true,
    },
    {
      title: "HIGH VOLTAGE AC",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      className: "tbl-text-normal",
    },
    {
      title: "Result",
      colSpan: 1,
      rowSpan: 1,
      isValueOnly: true,
      unBold: true,
      className: "tbl-text-normal",
     
    },
    {
      title: "Comments",
      colSpan: 4,
      rowSpan: 1,
      isValueOnly: true,
      leftAlign: true,
      className: "tbl-text-normal",
      
    },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "A. VERIFY ALL PROTECTIVE RELAYS ARE CLEAR OF TARGETS",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal",  accessor: "it3a", },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com122", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "B. WITH THE TRANSFORMER ENERGIZED, NOTE THE SOUND UNDER LOAD AND NO LOAD CONDITIONS. ABNORMAL SOUNDS OF RATTLING, VIBRATIONS OR TRACKING ARE INDICATIONS OF BREAKDOWN IN INSULATION, LOOSE CABLE TERMINATIONS AND LOOSE BUS COMPONENTS.",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it3b" },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com126", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "C. DEENERGIZE 12KVAC. UNRACK THE AC BREAKER, AND IF APPLICABLE, OPEN THE 12KVAC KNIFE SWITCH. VERIFY THE TRANSFORMER BECOMES SILENT.  ",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it3c", formatter: procedureFormatter },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com130", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "D. USING HIGH VOLTAGE PROTECTIVE GLOVES, OPEN THE TRANSFORMER CABINET TO GIVE ACCESS TO THE TRANSFORMER.  ",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it3d", formatter: procedureFormatter },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com134", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "E. VERIFY ALL VOLTAGE DANGEROUS TO LIFE HAS BEEN REMOVED.  ",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it3e", formatter: procedureFormatter },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com138", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "F. CONNECT A GROUND STRAP FROM TRANSFORMER TO GROUND TO ELIMINATE ANY STATIC CHARGES THAT MAY BE PRESENT.  ",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it3f", formatter: procedureFormatter },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com142", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "G. BEGIN VISUAL INSPECTION OF TRANSFORMER. CHECK FOR SIGNS OF TRACKING, INSULATION BREAKDOWN, COIL BUCKLING, AND BURNS.",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it3g" },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com146", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "H. CHECK FOR SIGNS OF MOISTURE",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it3h" },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com150", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "I. CLEAN THE TRANSFORMER, INSULATORS AND CUBICLE WITH AN INDUSTRIAL VACUUM CLEANER.  ",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it3i", formatter: procedureFormatter },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com154", className: "tbl-text-normal" },
  ],
},

// --- Section 4: RECTIFIER COMPARTMENT ---
{
  heights: {
    header1: "auto",
    header2: "auto",
  },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "4",
      colSpan: 1,
      rowSpan: 8,
      className: "tbl-text-normal",
      accessor: "",
      isTitleOnly:true,
      topAlign:true,
    },
    {
      title: "RECTIFIER COMPARTMENT",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      className: "tbl-text-normal",
    },
    {
      title: "Result",
      colSpan: 1,
      rowSpan: 1,
      isValueOnly: true,
      unBold: true,
      className: "tbl-text-normal",
     
    },
    {
      title: "Comments",
      colSpan: 4,
      rowSpan: 1,
      isValueOnly: true,
      leftAlign: true,
      className: "tbl-text-normal",
     
    },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "A. PRIOR TO OPENING THE RECTIFIER CABINET, VERIFY THE 12KVAC IS STILL DEENERGIZED.  ",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it4a" , formatter: procedureFormatter},
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com202", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "B. OPEN DC MAIN AND EACH FEEDER BREAKER.  ",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it4b", formatter: procedureFormatter },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com206", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "C. UNRACK EACH FEEDER BREAKER AND DC MAIN TO THE DISCONNECT POSITION.  ",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it4c", formatter: procedureFormatter },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com210", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "D. USING HIGH VOLTAGE GLOVES OPEN THE RECTIFIER CABINET.  ",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it4d", formatter: procedureFormatter },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com214", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "E. VERIFY VOLTAGE DANGEROUS TO LIFE IS NOT PRESENT.  ",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it4e" , formatter: procedureFormatter},
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com218", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "F. CHECK EACH DIODE AND ASSOCIATED FUSE FOR DAMAGE, LEAKAGE, ETC.",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it4f" },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com222", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "G. IF APPLICABLE, CHECK SNUBBER ASSEMBLIES FOR LEAKING CAPACITORS AND BURNT RESISTORS.",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it4g" },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com226", className: "tbl-text-normal" },
  ],
},


// --- Section 5: DC CIRCUIT BREAKERS ---
{
  heights: {
    header1: "auto",
    header2: "auto",
  },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "5",
      colSpan: 1,
      rowSpan: 9,
      className: "tbl-text-normal",
      isTitleOnly:true,
      topAlign:true,
     
    },
    {
      title: "DC CIRCUIT BREAKERS",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      className: "tbl-text-normal",
    },
    {
      title: "Result",
      colSpan: 1,
      rowSpan: 1,
      isValueOnly: true,
      unBold: true,
      className: "tbl-text-normal",
      
    },
    {
      title: "Comments",
      colSpan: 4,
      rowSpan: 1,
      isValueOnly: true,
      leftAlign: true,
      className: "tbl-text-normal",
   
    },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "A. VERIFY THAT THE DC FEEDERS ARE DEENERGIZED AND RACKED OUT.  ",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it5a" , formatter: procedureFormatter},
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com230", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "B. CONDUCT VISUAL INSPECTION FOR CLEANLINESS WITHIN EACH BREAKER AND ARC CHUTE",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it5b" },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com234", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "C. CHECK ALL LINKAGES FOR SMOOTH OPERATION, LOOSE OR MISSING PARTS",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it5c" },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com238", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "D. REMOVE THE ARC CHUTE. TURN UPSIDE DOWN AND INSPECT. IF ARCLEX BARRIERS OR ARC RUNNERS ARE BADLY ERODED THEY MUST BE REPLACED.",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it5d" },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com242", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "E. CHECK THE MAIN CONTACTS FOR EXCESSIVE ARCING. REPLACE CONTACTS IF NECESSARY",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it5e" },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com246", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "F. WIPE CONTACTS, CLEAN AND LUBRICATE WITH CONTACT GREASE.  ",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it5f", formatter: procedureFormatter },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com250", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "G. CHECK CLOSING AND TRIP COILS FOR DAMAGE DUE TO POSSIBLE OVERHEATING",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it5g" },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com254", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "H. REPLACE THE BREAKER TO THE SERVICE POSITION.  ",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it5h", formatter: procedureFormatter },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com258", className: "tbl-text-normal" },
  ],
},

// --- Section 6: CONTROL CIRCUIT TEST ---
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "6",
      colSpan: 1,
      rowSpan: 2, // Only one substep (A)
      className: "tbl-text-normal",
      isTitleOnly:true,
      topAlign:true,
   
    },
    {
      title: "CONTROL CIRCUIT TEST",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      className: "tbl-text-normal",
    },
    {
      title: "Result",
      colSpan: 1,
      rowSpan: 1,
      isValueOnly: true,
      unBold: true,
      className: "tbl-text-normal",
    
    },
    {
      title: "Comments",
      colSpan: 4,
      rowSpan: 1,
      isValueOnly: true,
      leftAlign: true,
      dontJoinValues: true,
      className: "tbl-text-normal",
    },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "A. VERIFY BLUE LIGHT OPERATION AND REPAIR AS NECESSARY",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    {
      title: "Result",
      colSpan: 1,
      rowSpan: 1,
      isValueOnly: true,
      accessor: "it6a",
      unBold: true,
      className: "tbl-text-normal",
    },
    {
      title: "Comments",
      colSpan: 4,
      rowSpan: 1,
      isValueOnly: true,
      accessor: "com262",
      // bindingAccessor: "cond2",
      className: "tbl-text-normal",
    },
  ],
},

// --- Section 7: STRUCTURE MAINTENANCE ---
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "7",
      colSpan: 1,
      rowSpan: 12,
      className: "tbl-text-normal",
      isTitleOnly:true,
      topAlign:true,
     
    },
    {
      title: "STRUCTURE MAINTENANCE",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      className: "tbl-text-normal",
    },
    {
      title: "Result",
      colSpan: 1,
      rowSpan: 1,
      isValueOnly: true,
      unBold: true,
      className: "tbl-text-normal",
     
    },
    {
      title: "Comments",
      colSpan: 4,
      rowSpan: 1,
      isValueOnly: true,
      leftAlign: true,
      className: "tbl-text-normal",
      
    },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "A. CHECK EXHAUST FANS BY ADJUSTING THERMOSTAT TO TURN VENTILATION ON. RESET TO 90 DEGREES",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it7a" },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com272", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "B. WHERE APPLICABLE, VERIFY THAT LOUVERS ARE FREE AND MOVABLE. REPAIR AND LUBRICATE AS NECESSARY.",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it7b" },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com276", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "C. WHERE APPLICABLE, CHECK FAN BELTS FOR PROPER TENSION AND ALIGNMENT. REPLACE IF THEY SHOW SIGNS OF WEAR.",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it7c" },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com280", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "D. REPLACE ALL AIR FILTERS IN THE STRUCTURE, INCLUDING IN THE REAR OF THE STRUCTURE.  ",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it7d", formatter: procedureFormatter },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com284", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "E. CLEAN THE INTERIOR OF THE STRUCTURE USING A VACUUM CLEANER. STAINS MAY BE REMOVED WITH DENATURED ALCOHOL AND RAGS.  ",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it7e", formatter: procedureFormatter },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com288", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "F. ENSURE ALL LIGHTING IN THE STRUCTURE IS OPERABLE AND REPLACE AS NECESSARY.",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it7f" },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com292", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "G. CHECK FOR PROPER OPERATION OF EMERGENCY LIGHT UNITS BY TURNING OFF BREAKER ON AC CIRCUIT BREAKER PANEL",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it7g" },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com296", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "H. ENSURE EYEWASH CONTAINERS ARE UP TO DATE",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "it7h" },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "com300", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "I. CHECK FIRE EXTINGUISHERS AND ENSURE THEY ARE UP TO DATE",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "structI" },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "comI1", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "J. ENSURE THERE IS A GOOD SET OF PRINTS IN THE SUB.  ",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "structJ", formatter: procedureFormatter },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "comJ1", className: "tbl-text-normal" },
  ],
},
{
  heights: { header1: "auto", header2: "auto" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "K. LOG SUB MAINTENANCE COMPLETE IN LOG BOOK.  ",
      colSpan: 9,
      rowSpan: 1,
      isTitleOnly: true,
      leftAlign: true,
      unBold: true,
      className: "tbl-text-normal",
    },
    { title: "Result", colSpan: 1, rowSpan: 1, isValueOnly: true, unBold: true, className: "tbl-text-normal", accessor: "structK", formatter: procedureFormatter },
    { title: "Comments", colSpan: 4, rowSpan: 1, isValueOnly: true, accessor: "comK1", className: "tbl-text-normal" },
  ],
},




    ]

    export const BIAnnaulTestSchemaInfo = [
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "MAINTAINER",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        // isTitleOnly: true,
         formatter: (id) => {
          return <SignatureImageImproved width={"30%"} signatureImage={id} />;
        },
        accessor: "sign",
        leftAlign:true,
      },
      {
        title: "Date",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        // isTitleOnly: true,
        accessor: "date",
        leftAlign:true,
      },
    ],
  },
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "SUPERVISOR",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        // isTitleOnly: true,
         formatter: (id) => {
          return <SignatureImageImproved width={"30%"} signatureImage={id} />;
        },
        accessor: "sign2",
        leftAlign:true,
      },
      {
        title: "Date",
        colSpan: 1,
        rowSpan: 1,
        className: "tbl-text-normal",
        // isTitleOnly: true,
        accessor: "date2",
        leftAlign:true,
      },
    ],
  },
  
];


// WEBPACK FOOTER //
// ./src/components/Reports/SDMTS/BIAnnualTest/BIAnnaulTestSchema.jsx